import { useEffect, useRef } from 'react';
import styles from './ResultQuiz.module.css';
import { motion } from 'motion/react';

import snow from '../../assets/video/snow2.webm';

export const ResultQuiz = ({ playerSrc }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    let idTimeout = '';
    if (!video) return;

    // остановка видео на 7 секунде, чтобы был игрок на экране, а не белый фон
    // const handleTimeUpdate = () => {
    //   if (video.currentTime >= 7) {
    //     video.pause();
    //     video.currentTime = 7;
    //   }
    // };

    idTimeout = setTimeout(() => {
      video.play().catch((error) => {});
    }, 1000);

    // video.addEventListener('timeupdate', handleTimeUpdate);

    return () => {
      clearTimeout(idTimeout);
      // video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, []);

  return (
    <div className={styles.wrapper}>
      <motion.div
        transition={{ duration: 0.25 }}
        exit={{ opacity: 0 }}
        className={styles.snow}
      >
        <video autoPlay="autoplay" muted="muted" playsInline>
          <source src={snow} type="video/webm"></source>
        </video>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        exit={{ opacity: 0 }}
        className={styles.playerVideo}
      >
        {playerSrc && (
          <video muted="muted" playsInline ref={videoRef} loop>
            <source src={playerSrc} type="video/webm"></source>
          </video>
        )}
      </motion.div>
    </div>
  );
};
